import CRUDCategoryList from '../../features/CRUD/CRUDCategory/CRUDCategoryList'
import "./Crudpages.scss"

const CRUDCategory = () => {
  return (
    <div>
       <CRUDCategoryList />
    </div>
  )
}

export default CRUDCategory